import { Create, useForm } from '@refinedev/antd'
import { Form, Input, InputNumber, Switch } from 'antd'

const { TextArea } = Input

export default function CategoryCreatePage() {
  const { formProps, saveButtonProps } = useForm({
    resource: 'categories',
    action: 'create',
  })

  return (
    <Create title="Dodaj kategoriju" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Naziv"
          name="name"
          rules={[{ required: true, message: 'Naziv je obavezan' }]}
        >
          <Input placeholder="npr. Mršavljenje" />
        </Form.Item>
        <Form.Item
          label="Slug (URL)"
          name="slug"
          rules={[
            { required: true, message: 'Slug je obavezan' },
            { pattern: /^[a-z0-9]+(?:-[a-z0-9]+)*$/, message: 'Samo mala slova, brojevi i crtice' },
          ]}
        >
          <Input placeholder="mrsavljenje" />
        </Form.Item>
        <Form.Item label="Opis" name="description">
          <TextArea rows={3} />
        </Form.Item>
        <Form.Item label="Redosled prikaza" name="sortOrder" initialValue={0}>
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="Aktivna" name="active" valuePropName="checked" initialValue={true}>
          <Switch />
        </Form.Item>
      </Form>
    </Create>
  )
}
